var path = '/components/directives/customfield/media_file.tpl.html';
var html = "<al-media-form-field\n        current-selected-file=\"field.ngModel\"\n        on-file-select=\"field.updateFileModel(file)\"\n        start-directory-uuid=\"field.definition.startDirectory\"\n        field-label=\"field.definition.name\"\n        allowed-types=\"[]\"\n        size=\"field.definition.fieldSize || 'small'\"\n        allowed-mimes=\"[]\"></al-media-form-field>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/media_file.tpl.html
// module id = 1994
// module chunks = 1